import { Flex } from '@chakra-ui/react'
import { ISharedDiagnostic } from '../../../../types/diagnostics'
import PatientInfo from './PatientInfo'
import Header from './Header'
import SharedDiagnosticInfo from './SharedDiagnosticInfo'
import { useGetPatient } from '../../../../api/api_hooks/patients'
import InvoiceInfo from './InvoiceInfo'

export default function SidBarInfo({
  diagnosticData,
}: {
  diagnosticData: ISharedDiagnostic | null
}) {
  const { data: patientData } = useGetPatient()
  const isClosed = diagnosticData?.status === 'closed'

  return (
    <Flex
      bg={'gray.50'}
      direction={'column'}
      height={'100%'}
      p={4}
      position={'sticky'}
      overflowY="auto"
    >
      {patientData && (
        <>
          <Header patientData={patientData} />
          <PatientInfo patientData={patientData} />
          {diagnosticData && (
            <SharedDiagnosticInfo diagnosticData={diagnosticData} />
          )}
          {diagnosticData && isClosed && (
            <InvoiceInfo diagnosticData={diagnosticData} />
          )}
        </>
      )}
    </Flex>
  )
}
